import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import LegalDocPage from "../components/feature/LegalDocPage";
import LegalLangRedirect from "../components/feature/LegalLangRedirect";

const LEGAL_SLUGS = ["privacy-policy", "terms", "pi-consent", "instagram-data-deletion", "account-deletion"] as const;

const routes: RouteObject[] = [
  ...LEGAL_SLUGS.flatMap((slug) => [
    { path: `/${slug}`, element: <LegalLangRedirect slug={slug} /> },
    { path: `/en/${slug}`, element: <LegalDocPage lang="en" slug={slug} /> },
    { path: `/ko/${slug}`, element: <LegalDocPage lang="ko" slug={slug} /> },
  ]),
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
